import '@iris/ui/theme.css';

import { bootI18n } from '@iris/i18n/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';

const container = document.getElementById('root');
if (container) {
  void bootI18n().then((i18n) => {
    createRoot(container).render(
      <StrictMode>
        <App i18n={i18n} />
      </StrictMode>,
    );
  });
}
